import { usePatientInfoStore } from './patient-info.js';
import { useMessageStore } from './message.js';
import { useRoomsStore } from './rooms.js';

// Combined helper for components that need multiple Vuex modules
export function useMyPatientsStore() {
  const patientInfoStore = usePatientInfoStore();
  const messageStore = useMessageStore();
  const roomsStore = useRoomsStore();

  return {
    patientInfoStore,
    messageStore,
    roomsStore,
  };
}

